import MiranaState from './mirana-state';
import MiranaStateEditor from './mirana-state-editor';
import AppAction from './actions/action';
import * as actions from './actions/action-types';

export class MiranaReducer {

    public static reduce(currentState: MiranaState = new MiranaState(), action: AppAction) {
        const miranaStateEditor = new MiranaStateEditor(currentState);
        switch (action.type) {
            case actions.SET_IS_AUTHENTICATED:
                if (action.payload && action.payload.value) {
                    miranaStateEditor.setIsAuthenticated(action.payload.value);
                }
                break;

            case actions.SET_IS_LOADING:
                miranaStateEditor.setIsLoading(action.payload.value);
                break;
            case actions.SET_USER_DETAILS:
                if (action.payload && action.payload.userDetails) {
                    miranaStateEditor.setUserDetails(action.payload.userDetails);
                }
                break;
            case actions.SET_CARTERA_DETALLE:
                if (action.payload && action.payload.fuerzaVentaId && action.payload.carteraDetalle) {
                    miranaStateEditor.setCarteraDetalle(action.payload.fuerzaVentaId, action.payload.carteraDetalle);
                }
                break;
            default:
                break;
        }
        return miranaStateEditor.commit();
    }
}



// WEBPACK FOOTER //
// ./src/reduxstore/mirana-reducer.ts